// extracted by mini-css-extract-plugin
export var component = "focusWithin-module--component--0K4WT";
export var outset = "focusWithin-module--outset--euFGa";